
<template>
	<div class="box">
	  <div class="boxTitle">top10进出口贸易额关口</div>
	  <div class="echart">
      <div class="echartItem">
        <div id="enterEchart" style="width:100%;height: 25vh;"></div>
        <div style="text-align: center;font-size: 16px;padding-bottom: 15px;">进口贸易额</div>
      </div>
      <div class="echartItem">
        <div id="outEchart" style="width:100%;height: 25vh;"></div>
        <div style="text-align: center;font-size: 16px;padding-bottom: 15px;">出口贸易额</div>
      </div>
	   <!-- <dv-active-ring-chart :config="config" style="width:300px;height:300px" /> -->
	  </div>
	</div>
</template>

<script>
	export default {
		name: "One",
		data() {
			return {
        charts:null,
        option:{},
        charts1:null,
        option1:{}
      }
    },
    mounted() {
      this.dataInfo();
      this.dataInfo1();
     },
     methods: {
       dataInfo() {
         this.charts = this.$echarts.init(document.getElementById('enterEchart'));
         this.option = {
            tooltip: {
               trigger: 'item'
             },
             legend: {
               type: 'scroll',
                  orient: 'vertical',
                  right: 0,
                  top: 20,
                  bottom: 20,
               textStyle: {
                   color: '#fff' // 设置文字颜色为白色
               }
             },
             series: [
               {
                 name: '进口贸易额',
                 type: 'pie',
                 radius: ['40%', '70%'],
                 avoidLabelOverlap: false,
                 label: {
                   show: false,
                   position: 'right',
                   textStyle: {
                       color: '#fff' // 设置文字颜色为白色
                   }
                 },
                 data: [
                   { value: 4083947.1000, name: '天津海关 12%' },
                   { value: 3283947.1000, name: '长沙海关 10%' },
                   { value: 3083947.1000, name: '南京海关 8%' },
                   { value: 2983947.1000, name: '北京海关  8%' },
                   { value: 2983947.1000, name: '虎门海关  8%' },
                   { value: 2983947.1000, name: '湖南海关 8%' },
                   { value: 2983947.1000, name: '汕头海关 8%' },
                   { value: 2983947.1000, name: '安徽海关 8%' },
                   { value: 2383947.1000, name: '深圳海关 8%' },
                   { value: 2283947.1000, name: '罗湖海关 8%' }
                 ]
               }
             ]
         }
         this.charts.setOption(this.option);
       },
       dataInfo1() {
         this.charts1 = this.$echarts.init(document.getElementById('outEchart'));
         this.option1 = {
            tooltip: {
               trigger: 'item'
             },
             legend: {
               type: 'scroll',
                  orient: 'vertical',
                  right: 0,
                  top: 20,
                  bottom: 20,
               textStyle: {
                   color: '#fff' // 设置文字颜色为白色
               }
             },
             series: [
               {
                 name: '进口贸易额',
                 type: 'pie',
                 radius: ['40%', '70%'],
                 avoidLabelOverlap: false,
                 label: {
                   show: false,
                   position: 'right',
                   textStyle: {
                       color: '#fff' // 设置文字颜色为白色
                   }
                 },
                 data: [
                   { value: 4083947.1000, name: '天津海关 12%' },
                   { value: 3283947.1000, name: '长沙海关 10%' },
                   { value: 3083947.1000, name: '南京海关 8%' },
                   { value: 2983947.1000, name: '北京海关  8%' },
                   { value: 2983947.1000, name: '虎门海关  8%' },
                   { value: 2983947.1000, name: '湖南海关 8%' },
                   { value: 2983947.1000, name: '汕头海关 8%' },
                   { value: 2983947.1000, name: '安徽海关 8%' },
                   { value: 2383947.1000, name: '深圳海关 8%' },
                   { value: 2283947.1000, name: '罗湖海关 8%' }
                 ]
               }
             ]
         }
         this.charts1.setOption(this.option1);
       }


   }
  }
</script>

<style scoped>
  .echart{
    display:flex;
    justify-content:center;
    max-width: 1400px;
    margin:auto
  }
  .echartItem{
    flex:1
  }
</style>



// WEBPACK FOOTER //
// src/components/left/one.vue